/* AtopicV — Motion-Fundament
   ==================================================================
   EINE Scroll-Quelle und EIN Bewegungs-Vokabular fuer die ganze Seite.

   Warum: jede Section hatte bisher ihre eigene rAF-Schleife mit eigenem
   getBoundingClientRect, eigenen Easings und eigenen Schwellen. Sieben
   Sections = sieben Handschriften und sieben Layout-Reflows pro Frame.

   Der heikle Punkt ist der Scroller. base.css setzt ab 990px html/body
   auf overflow:hidden und macht .page-wrapper zum echten Scroll-Container;
   darunter scrollt das Fenster. Lenis UND ScrollTrigger muessen auf
   denselben, breakpoint-abhaengigen Scroller zeigen — naiv ans window
   gehaengt passiert auf dem Desktop schlicht nichts.

   Sections greifen ueber window.AtvMotion zu.
   ================================================================== */
(function () {
  "use strict";

  var W = window;
  var D = document;

  /* Der Stub aus theme.liquid hat die Anmeldungen der Sections gesammelt,
     solange die Bibliotheken noch nicht da waren. */
  var vorab = (W.AtvMotion && W.AtvMotion._q) || [];

  /* Ohne GSAP bleibt die Seite statisch lesbar: bereit() feuert dann NIE und
     die Sections behalten ihren CSS-Grundzustand. Ein Aufruf ohne GSAP wuerde
     mitten in der Choreografie werfen — Stillstand ist hier das ehrlichere
     Verhalten als ein halb aufgebauter Zustand. */
  if (!W.gsap || !W.ScrollTrigger) {
    W.AtvMotion = {
      aktiv: false,
      sanft: true,
      lenis: null,
      bereit: function () {},
    };
    return;
  }

  gsap.registerPlugin(ScrollTrigger);
  if (W.SplitText) gsap.registerPlugin(SplitText);

  var sanftMQ = W.matchMedia("(prefers-reduced-motion: reduce)");

  /* ── Haus-Grammatik ───────────────────────────────────────────────
     EIN Satz Kurven und Zeiten fuer die ganze Seite. Jede Section greift
     hier zu, statt eigene Werte zu erfinden. Das ist der Unterschied
     zwischen "sieben Animationen" und "eine Handschrift". */
  var EASE = {
    auftritt: "power3.out", // Elemente kommen herein
    abgang: "power2.in", // Elemente gehen hinaus
    enthuellung: "expo.out", // schwere Titel-Reveals, langer Auslauf
    weich: "power1.inOut", // Zustandswechsel
    scrub: "none", // scroll-gebunden: das Scrollen IST die Kurve
  };
  var ZEIT = { kurz: 0.5, mittel: 0.9, lang: 1.5 };
  var VERSATZ = 0.075; // Grundtakt fuer stagger

  /* ── Scroller ─────────────────────────────────────────────────────
     Ab 990px ist .page-wrapper der Scroll-Container, darunter das Fenster. */
  var DESKTOP = W.matchMedia("(min-width: 990px)");

  function scrollerJetzt() {
    var pw = D.querySelector(".page-wrapper");
    return DESKTOP.matches && pw ? pw : W;
  }

  var lenis = null;
  var tickerFn = null;

  function lenisAus() {
    if (tickerFn) {
      gsap.ticker.remove(tickerFn);
      tickerFn = null;
    }
    if (lenis) {
      lenis.destroy();
      lenis = null;
    }
    D.documentElement.classList.remove("atv-lenis");
  }

  function lenisAn() {
    lenisAus();
    if (sanftMQ.matches || !W.Lenis) return;

    var el = scrollerJetzt();
    var opt = {
      lerp: 0.13, // Traegheit: glatt, aber nicht sirupartig (28.07.: von 0.085 rauf — Jasons Befund "scrollen ist scheisse" bei fast 10 Bildschirmhoehen Gesamtstrecke)
      smoothWheel: true,
      syncTouch: false, // Touch bleibt nativ — synthetischer Touch fuehlt sich auf echten Geraeten traege an
      autoRaf: false, // gsap.ticker treibt Lenis, damit beide exakt denselben Frame teilen
    };
    if (el !== W) {
      opt.wrapper = el;
      /* Lenis liest die Scrollhoehe bei Element-Wrappern aus wrapper.scrollHeight;
         content dient nur dem ResizeObserver. .page-wrapper selbst ist auf 100dvh
         fixiert und wuerde nie feuern — deshalb der wachsende Inhalt darin. */
      opt.content = el.querySelector(":scope > .content-for-layout") || el;
    }

    lenis = new W.Lenis(opt);
    D.documentElement.classList.add("atv-lenis");

    lenis.on("scroll", ScrollTrigger.update);
    tickerFn = function (zeit) {
      lenis.raf(zeit * 1000);
    };
    gsap.ticker.add(tickerFn);
    gsap.ticker.lagSmoothing(0);
  }

  /* ScrollTrigger und Lenis auf denselben Scroller ziehen. Laeuft auch ohne
     Lenis (reduced motion), weil ScrollTrigger den Scroller ohnehin braucht. */
  function scrollerVerdrahten() {
    ScrollTrigger.defaults({ scroller: scrollerJetzt() });
  }

  scrollerVerdrahten();
  lenisAn();

  /* Breakpoint-Wechsel: Scroller-Element wechselt, also Lenis neu aufsetzen und
     ScrollTrigger neu vermessen. Dieser Listener wird VOR denen der Sections
     registriert (das Fundament laedt zuerst), deshalb sehen Sections, die mit
     gsap.matchMedia arbeiten, beim Rebuild bereits den neuen Scroller. */
  DESKTOP.addEventListener("change", function () {
    scrollerVerdrahten();
    lenisAn();
    /* Sequenzen, die unter 990px ausgeblendet waren, wurden bewusst nicht
       aufgebaut. Wird das Fenster breiter, holen sie das jetzt nach. */
    try {
      sequenzen();
    } catch (e) {
      console.error("[atv-motion] Sequenzen", e);
    }
    ScrollTrigger.refresh();
  });

  sanftMQ.addEventListener("change", function () {
    lenisAn();
    ScrollTrigger.refresh();
  });

  /* Lenis muss nach einem Refresh die Masse neu kennen (Bilder, Videos, Fonts). */
  ScrollTrigger.addEventListener("refresh", function () {
    if (lenis) lenis.resize();
  });

  /* ── Zeilen-Reveal ────────────────────────────────────────────────
     Die Signature-Bewegung: der Text wird in Zeilen zerlegt, jede Zeile
     sitzt in einem clippenden Kaesten und schiebt von unten heraus. Ohne
     das erscheinen Headlines als Block — der sichtbarste Unterschied
     zwischen "eingeblendet" und "inszeniert".

     autoSplit haelt die Zerlegung bei Font-Load und Resize korrekt;
     onSplit baut die Animation danach neu auf, sonst haengt sie an
     verwaisten Zeilen-Elementen. */
  function zeilen(el, vars) {
    vars = vars || {};
    if (!el || !W.SplitText) return null;

    var bauen = vars.bauen; // (zeilen[]) => Timeline | Tween

    /* linesClass ohne Bindestrich — SplitText haengt "-mask" an jedes WORT des
       Klassennamens. "atv-zeile" wuerde zu "atv-mask-zeile-mask"; "atvzeile"
       ergibt sauber "atvzeile-mask". */
    return new SplitText(el, {
      type: "lines",
      mask: "lines",
      linesClass: "atvzeile",
      autoSplit: true,
      aria: "auto",
      onSplit: function (self) {
        if (bauen) return bauen(self.lines, self);
        /* Grosszuegig ueber 100%: der Masken-Kasten braucht Innenabstand fuer
           weite text-shadow-Halos, und die Zeile muss auch DEN verlassen. */
        return gsap.from(self.lines, {
          yPercent: 175,
          duration: ZEIT.lang,
          ease: EASE.enthuellung,
          stagger: VERSATZ,
          scrollTrigger: vars.scrollTrigger || null,
        });
      },
    });
  }

  /* ── Seitenweiter Abschnitts-Auftritt ─────────────────────────────
     Die Listen-Reveals der Abschnitte laufen bereits ueber native
     CSS-Scroll-Animationen (animation-timeline: view()) — nachgemessen und
     funktionierend. Die bleiben unangetastet: sie kosten kein JS und tun,
     was sie sollen.

     Was fehlte, ist die Ueberschrift. `.atv-claim` wird von acht Abschnitten
     geteilt und hatte KEINEN Auftritt — das groesste Element jeder Section
     stand einfach da, waehrend die kleinen Zeilen darunter hereinkamen.
     Sie bekommt hier dieselbe maskierte Zeilen-Enthuellung wie der Opener,
     damit die ganze Seite eine Handschrift hat statt zwei.

     Eyebrow und Lede haengen mit dran: eine Ueberschrift, die sich allein
     enthuellt, waehrend ihre Beitexte reglos danebenstehen, wirkt zufaellig,
     nicht komponiert. */
  /* Die Ueberschriften heissen nicht ueberall gleich — vier Abschnitte teilen
     sich .atv-claim, Doku und Vertrauen bringen eigene BEM-Namen mit. */
  /* 05.09.: Die Liste zielte ins Leere. .atv-claim & Co. stammen aus der
     Section-Generation vor dem Neubau — die heutige Startseite benutzt keine
     davon. Gemessen stand JEDER grosse Textmoment reglos da, darunter mit
     418 px das groesste Element der Seite. Genau Jasons "null motion":
     nicht kaputt, sondern an Klassen gehaengt, die es nicht mehr gibt. */
  /* 05.09. II: Derselbe Befund noch einmal, eine Ebene weiter. Nachgemessen
     ueber alle Vorlagen stand auf JEDER Unterseite der groesste Text reglos
     da — der Seitentitel auf Wirkstoffe, Ueber uns, FAQ und Kontakt (je 99 px)
     und die 70-px-Aussage der Produktseite. Die Startseite hatte nach dem
     Fix eine Handschrift, der Rest des Shops keine. */
  /* 05.09. II: Die vier Startseiten-Eintraege sind wieder heraus. Der
     Selektor-Fix von heute frueh hatte sie zum ersten Mal ueberhaupt zum
     Laufen gebracht — gestern standen sie tot im Code. Jason: "die scroll
     motion waren zuviel". Zusammen mit der Parallaxe, die aus atv.css
     entfernt wurde, bewegt sich auf der Startseite jetzt nur noch die
     16-px-Blende von .atv2-auf, also derselbe Umfang wie gestern.
     Die Unterseiten behalten die Zeilen-Enthuellung: dort war sie nie zu
     viel, sondern der Unterschied zwischen Auftritt und Textdokument.
     Zurueckholen heisst: die beiden Zeilen unten wieder eintragen. */
  var TITEL =
    ".atv-claim, .atv-doku__claim, .atv-bl__claim," +
    ".atv-seite__titel, .atv2-labor__aussage, .atv-pdp-body__aussage";
  /* Opener und Serum haben eine eigene, aufwendigere Choreografie. Da darf
     kein zweites System hineinregieren. */
  var EIGENE_REGIE = ".atv-opener, .atv-se";

  function abschnitteInszenieren() {
    if (sanftMQ.matches || !W.SplitText) return;

    D.querySelectorAll(TITEL).forEach(function (titel) {
      if (titel.closest(EIGENE_REGIE)) return;
      if (titel.dataset.atvInszeniert) return;
      titel.dataset.atvInszeniert = "1";

      /* Doku und Vertrauen blenden ihre Bloecke bereits ueber [data-reveal] und
         animation-timeline:view() ein. Nur die Ueberschrift wird uebernommen —
         ihr data-reveal faellt weg, damit nicht zwei Reveals uebereinander
         liegen. Eyebrow und Lede behalten ihren CSS-Auftritt; wuerde ich sie
         hier zusaetzlich anfassen, animierten zwei Systeme dieselbe
         Eigenschaft desselben Elements. */
      var eigenesReveal = titel.hasAttribute("data-reveal");
      if (eigenesReveal) titel.removeAttribute("data-reveal");

      /* Drei der neuen Titel sitzen in einem .atv2-auf-Block, der beim
         Eintritt opacity UND translateY(34px) faehrt. Zusammen mit der
         Zeilen-Enthuellung waeren das zwei vertikale Bewegungen auf
         derselben Schrift — sie ueberlagern sich sichtbar. Der Block
         behaelt hier nur die Blende, die Bewegung fuehren die Zeilen. */
      var aufBlock = titel.closest(".atv2-auf");
      if (aufBlock) aufBlock.classList.add("atv2-auf--nur-blende");

      var block = titel.parentElement;
      var eyebrow =
        !eigenesReveal && block && block.querySelector(".atv-eyebrow");
      var lede = !eigenesReveal && block && block.querySelector(".atv-lede");

      zeilen(titel, {
        bauen: function (zn) {
          /* Bewusst set + to statt from, und KEIN once:

             from() merkt sich den aktuellen Wert als Ziel. Zerlegt autoSplit
             beim Font-Load waehrend eines laufenden Reveals neu, stirbt die
             alte Animation mitten im Lauf und die neue merkt sich den halben
             Zustand als Ziel — die Zeile bleibt dann fuer immer im Kasten
             stecken. Genau das ist bei der Fragen-Section passiert: Trigger
             abgefeuert und durch once weggeraeumt, Zeilen trotzdem verborgen.

             set() auf einen festen Startwert und to() auf einen festen
             Zielwert ist dagegen idempotent — egal wie oft neu zerlegt oder
             neu vermessen wird, das Ergebnis ist immer dasselbe. */
          gsap.set(zn, { yPercent: 175 });
          if (eyebrow) gsap.set(eyebrow, { opacity: 0, y: 12 });
          if (lede) gsap.set(lede, { opacity: 0, y: 16 });

          var tl = gsap.timeline({
            scrollTrigger: {
              trigger: titel,
              start: "top 88%",
              toggleActions: "play none none none",
            },
          });
          if (eyebrow)
            tl.to(
              eyebrow,
              { opacity: 1, y: 0, duration: ZEIT.kurz, ease: EASE.auftritt },
              0,
            );
          tl.to(
            zn,
            {
              yPercent: 0,
              duration: ZEIT.lang,
              ease: EASE.enthuellung,
              stagger: VERSATZ,
            },
            0.08,
          );
          if (lede)
            tl.to(
              lede,
              { opacity: 1, y: 0, duration: ZEIT.mittel, ease: EASE.auftritt },
              0.3,
            );
          return tl;
        },
      });
    });
  }

  /* ── Bild-Sequenz am Scroll ───────────────────────────────────────
     Ein Stapel Einzelaufnahmen, von denen der Scroll genau eine zeigt —
     damit sich die Flasche dreht, waehrend man den Text daneben liest.
     Das Produkt bleibt die Konstante, der Inhalt daneben wechselt.

     Bewusst gestapelte <img> statt Canvas: bei elf Bildern ist das
     einfacher, braucht keine Vorlade-Verwaltung und der Browser
     dekodiert selbst. Umgeschaltet wird nur bei echtem Bildwechsel,
     nicht in jedem Frame.

     Markup: <div data-atv-sequenz="<Spur-Selektor>"> mit <img>-Kindern.
     Ohne Wert dient der umgebende <section> als Spur. */
  function sequenzen() {
    if (sanftMQ.matches) return;

    D.querySelectorAll("[data-atv-sequenz]").forEach(function (stapel) {
      if (stapel.dataset.atvSequenzAktiv) return;

      /* Nicht dargestellt — etwa unter 990px ausgeblendet — heisst: nichts
         aufbauen und vor allem nichts laden. display:none haelt den Browser
         nicht davon ab, <img src> zu holen; darum tragen die Aufnahmen
         data-src und bekommen ihr src erst hier. */
      if (!stapel.offsetParent && getComputedStyle(stapel).position !== "fixed")
        return;
      stapel.dataset.atvSequenzAktiv = "1";

      var bilder = stapel.querySelectorAll("img");
      if (bilder.length < 2) return;

      bilder.forEach(function (b) {
        if (b.dataset.src && !b.getAttribute("src"))
          b.setAttribute("src", b.dataset.src);
      });

      var spurWahl = stapel.getAttribute("data-atv-sequenz");
      var spur =
        (spurWahl && D.querySelector(spurWahl)) ||
        stapel.closest("section") ||
        stapel;

      gsap.set(bilder, { autoAlpha: 0 });
      gsap.set(bilder[0], { autoAlpha: 1 });

      var stand = { i: 0 };
      var letzter = 0;

      gsap.to(stand, {
        i: bilder.length - 1,
        ease: "none",
        scrollTrigger: {
          trigger: spur,
          /* Start exakt beim Eintreffen des Abschnitts, nicht schon beim
             Hereinscrollen: sonst ist die Aufnahme bereits durchgedreht,
             bevor man den ersten Wirkstoff gelesen hat — gemessen stand bei
             'top 30%' schon Bild 4 von 11 am Anfang. Das Ende faellt mit dem
             Abloesen des klebenden Objekts zusammen. */
          start: "top top",
          end: "bottom 60%",
          scrub: 0.5,
          invalidateOnRefresh: true,
        },
        onUpdate: function () {
          var n = Math.min(bilder.length - 1, Math.max(0, Math.round(stand.i)));
          if (n === letzter) return;
          gsap.set(bilder[letzter], { autoAlpha: 0 });
          gsap.set(bilder[n], { autoAlpha: 1 });
          letzter = n;
        },
      });
    });
  }

  /* ── Bereit-Haken ─────────────────────────────────────────────────
     Sections warten hierauf statt auf DOMContentLoaded, damit die
     Reihenfolge Fundament -> Section garantiert ist. */
  var wartend = vorab.slice();
  var istBereit = false;

  function bereit(fn) {
    if (istBereit) {
      fn();
      return;
    }
    wartend.push(fn);
  }

  function losfeuern() {
    if (istBereit) return;
    istBereit = true;
    wartend.splice(0).forEach(function (fn) {
      try {
        fn();
      } catch (e) {
        console.error("[atv-motion]", e);
      }
    });
    try {
      abschnitteInszenieren();
    } catch (e) {
      console.error("[atv-motion] Abschnitte", e);
    }
    try {
      sequenzen();
    } catch (e) {
      console.error("[atv-motion] Sequenzen", e);
    }
    ScrollTrigger.refresh();
  }

  /* ZUERST veroeffentlichen, DANN feuern. Diese Datei laedt mit defer, also ist
     readyState beim Ausfuehren bereits 'interactive' — losfeuern() liefe hier
     sofort. Stuende die Zuweisung danach, saehen die Sections in ihrem
     bereit()-Callback noch den Stub aus theme.liquid, der weder EASE noch ZEIT
     kennt. Genau das ist beim ersten Lauf passiert. */
  W.AtvMotion = {
    aktiv: true,
    get sanft() {
      return sanftMQ.matches;
    },
    get lenis() {
      return lenis;
    },
    get scroller() {
      return scrollerJetzt();
    },
    EASE: EASE,
    ZEIT: ZEIT,
    VERSATZ: VERSATZ,
    zeilen: zeilen,
    bereit: bereit,
  };

  if (D.readyState === "loading") {
    D.addEventListener("DOMContentLoaded", losfeuern, { once: true });
  } else {
    losfeuern();
  }
})();
